import { render, staticRenderFns } from "./FileSettingsModal.vue?vue&type=template&id=94dc7366&"
import script from "./FileSettingsModal.vue?vue&type=script&lang=js&"
export * from "./FileSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./FileSettingsModal.vue?vue&type=style&index=0&id=94dc7366&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports